import { combineReducers } from 'redux';
import * as types from './action-types';
import YFRedFactory from '@src/reducer/ReducerFactory.js';

const initialState = {
  isFetching: false,
  status: '',
  token: ''
};

const yfsso = (state = initialState, action = {}) => {
  switch (action.type) {
    case `${types.FETCH_YELLOWFIN_SSO_TOKEN}_PENDING`:
      return Object.assign({}, state, {
        token: '',
        isFetching: true,
      });
    case `${types.FETCH_YELLOWFIN_SSO_TOKEN}_FULFILLED`:
      return Object.assign({}, state, {
        token: action.payload.data.data.loginSessionId,
        isFetching: false,
      });
    case `${types.FETCH_YELLOWFIN_SSO_TOKEN}_REJECTED`:
      return Object.assign({}, state, {
        token: '',
        status: 'failed',
        isFetching: false,
      });
    default:
      return state;
  }
}

export default combineReducers({
  yfsso,
  YFRedFactory,
});



// WEBPACK FOOTER //
// ./src/features/yellowfin/reducer.js